var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 85,
    viewBox: "0 0 99 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M48.7795 85C75.7197 85 97.559 82.7251 97.559 79.9188C97.559 77.1125 75.7197 74.8376 48.7795 74.8376C21.8393 74.8376 0 77.1125 0 79.9188C0 82.7251 21.8393 85 48.7795 85Z",
    fill: "#9D9D9C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_283_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.89 31C54.9312 31 61.45 24.4813 61.45 16.44C61.45 8.39874 54.9312 1.88 46.89 1.88C38.8487 1.88 32.33 8.39874 32.33 16.44C32.33 24.4813 38.8487 31 46.89 31Z",
    fill: "white",
    stroke: "#09314C",
    strokeWidth: 3.76,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.55 69.76C49.35 69.84 48.13 69.88 46.9 69.88C30.88 69.88 17.89 63.06 17.89 54.64C17.89 46.22 30.88 39.4 46.9 39.4C62.92 39.4 75.91 46.22 75.91 54.64C75.91 62.41 64.85 68.82 50.55 69.76Z",
    fill: "white",
    stroke: "#09314C",
    strokeWidth: 3.76,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.89 69.88H60.81",
    stroke: "#09314C",
    strokeWidth: 3.76,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.25 52.34L63.03 66.13L92.39 36.77",
    stroke: "#AACA11",
    strokeWidth: 16.0181,
    strokeMiterlimit: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_283_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.05,
    height: 71.79,
    fill: "white",
    transform: "translate(16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.54a5a2233507c1fd58042018965968a4.svg";
export { ForwardRef as ReactComponent };